module.exports = __webpack_public_path__ + "static/three-b3550b352522b2a0b8d8802bb0b25490.png";